/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseHotspotContentFragment} from '@amblique/contentful/app/contentful/fragments/hotspot-content/base-hotspot-content.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const HotspotContentFragment = gql`
  ${BaseHotspotContentFragment}
  ${BaseImageFragment}
  ${BaseVideoFragment}

  fragment HotspotContentFragment on HotspotContent {
    ...BaseHotspotContentFragment

    image {
      ...BaseImageFragment
    }
    mobileImage {
      ...BaseImageFragment
    }
    mobileVideo {
      ...BaseVideoFragment
    }
    video {
      ...BaseVideoFragment
    }
  }
`;
